import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { CommunityBelt } from "../components/CommunityBelt";
import { ManifestoBeats } from "../components/ManifestoBeats";
import { HowItWorks } from "../components/HowItWorks";
import { WaysToGive } from "../components/WaysToGive";
import { SustainingBandLive } from "../components/SustainingBand";
import { MeetTheStudents } from "../components/MeetTheStudents";
import { Impact } from "../components/Impact";
import { Footer } from "../components/Footer";
import { DonateComingSoonDialog } from "../components/DonateComingSoonDialog";
import { SEO } from "../lib/SEO";
import { useDiscovery } from "../lib/publicCampaigns";

/**
 * Home — day-one marketing landing (myrichaunt.org root).
 *
 * "Preview the platform" CTAs funnel to /preview (donor vs student
 * two-door gateway → into the /demo prototype).
 *
 * "Give" CTAs open the DonateComingSoonDialog wrapper — when
 * REACT_APP_DONATIONS_LIVE=true it renders the real Stripe checkout
 * (LiveDonateDialog); otherwise it renders the "Giving opens soon"
 * email capture. The Footer owns its own universal CTAs + dialog.
 */
export default function Home() {
  const navigate = useNavigate();
  const [donateOpen, setDonateOpen] = useState(false);

  const openPreview = () => navigate("/preview");
  const openDonate = () => setDonateOpen(true);
  // "Browse campaigns" goes to the real grid once enough students are live;
  // until then it opens the give dialog (no empty grid, no fake cards).
  const { visible: campaignsVisible } = useDiscovery();
  const openBrowse = campaignsVisible ? () => navigate("/campaigns") : openDonate;

  return (
    <main data-testid="home-page">
      <SEO
        title="My Rich Aunt — Direct Grants to Verified College Students"
        description="A 501(c)(3) helping verified college and graduate students cover the costs financial aid misses — through direct, tax-deductible grants funded by everyday donors."
        path="/"
      />
      <Navbar
        onStart={openPreview}
        onDonate={openDonate}
        primaryLabel="Preview the platform"
        secondaryLabel="Donate"
      />
      <Hero
        onStart={openPreview}
        onDonate={openDonate}
        primaryLabel="Preview the platform"
      />
      <CommunityBelt />
      <ManifestoBeats />
      <HowItWorks />
      <WaysToGive onDonate={openDonate} onBrowse={openBrowse} />
      <SustainingBandLive />
      <MeetTheStudents />
      <Impact />
      <Footer />
      <DonateComingSoonDialog
        open={donateOpen}
        onOpenChange={setDonateOpen}
      />
    </main>
  );
}
